import IncomeDetails from '../components/IncomeDetails'

function IncomeStatements() {
  return <IncomeDetails />
}

export default IncomeStatements
